import {AbstractAdminEntityService} from "./AbstractAdminEntityService";
import {HttpService} from "../http/HttpService";
import {ListResponse, Settings} from "../http/protocol";

export class SettingsService extends AbstractAdminEntityService<Settings,ListResponse> implements SettingsService{

    constructor(http: HttpService) {
        super("/settings", http);
    }

    getSettings(): Promise<Settings> {
        return this.http.get(`${this.entityPath}/`);
    }


    saveSettings(settings:Settings):Promise<any> {
        return this.http.put<Settings,Settings>(`${this.entityPath}/`, settings);
    }
}